// ═══════════════════════════════════════════════════════════════
// CONSUMO DA IA — quanto a análise está custando
// ═══════════════════════════════════════════════════════════════
//
// A OpenAI NÃO expõe saldo por chave de API: o endpoint de billing exige
// sessão do painel, não a chave. Então saldo não dá para mostrar aqui sem
// mentir. O que dá — e é o que responde a pergunta de verdade — é o CONSUMO:
// cada análise guarda os tokens que gastou, e a soma diz para onde o crédito
// está indo e quanto tempo ele deve durar.
//
// O preço vem de variável de ambiente (REACT_APP_OPENAI_PRECO_*, por milhão de
// tokens). Sem ela, o painel mostra tokens e não inventa valor — número de
// custo errado é pior do que nenhum, porque alguém decide em cima dele.
//
// A moeda também é configurável, e o padrão é DÓLAR porque é assim que a
// OpenAI cobra e que o crédito é carregado. Converter para real aqui exigiria
// um câmbio chutado, que envelhece sozinho e faz a conta bater errado com a
// fatura.

export const PRECO_ENTRADA = Number(process.env.REACT_APP_OPENAI_PRECO_ENTRADA || 0);
export const PRECO_SAIDA = Number(process.env.REACT_APP_OPENAI_PRECO_SAIDA || 0);
export const MOEDA = process.env.REACT_APP_OPENAI_MOEDA || "USD";
export const temPreco = () => PRECO_ENTRADA > 0 || PRECO_SAIDA > 0;

export const fmtMoeda = (v) =>
  Number(v || 0).toLocaleString("pt-BR", {
    style: "currency", currency: MOEDA,
    // Análise unitária custa centavos de dólar: com 2 casas tudo vira "US$ 0,01".
    minimumFractionDigits: 2, maximumFractionDigits: Math.abs(v) < 1 ? 4 : 2,
  });

/** Todas as análises já feitas, achatadas, com de quem são. */
export function analises(partners = []) {
  const saida = [];
  for (const p of partners || []) {
    for (const it of Array.isArray(p.interactions) ? p.interactions : []) {
      const a = it.analiseIa;
      if (!a?.ts) continue;
      saida.push({
        data: String(a.ts).slice(0, 10),
        modelo: a.modelo || "",
        entrada: Number(a.tokens_entrada || 0),
        saida: Number(a.tokens_saida || 0),
        total: Number(a.tokens_total || 0) || Number(a.tokens_entrada || 0) + Number(a.tokens_saida || 0),
        // Imagem e texto custam diferente: separar mostra o ganho de trocar
        // print por conversa exportada.
        tipo: a.tinha_conversa ? "conversa" : a.tinha_print ? "print" : "sem_prova",
        pedidoPor: a.pedido_por || "",
        empresa: p.name || "",
      });
    }
  }
  return saida.sort((a, b) => (b.data || "").localeCompare(a.data || ""));
}

export const custoDe = (entrada, saida) =>
  (entrada / 1_000_000) * PRECO_ENTRADA + (saida / 1_000_000) * PRECO_SAIDA;

/** O quadro que a gerência olha: quanto rodou, quanto gastou, em quê. */
export function resumoUso(partners = [], desde = null) {
  const lista = analises(partners).filter((a) => !desde || a.data >= desde);
  const porTipo = { conversa: 0, print: 0, sem_prova: 0 };
  let entrada = 0;
  let saida = 0;
  for (const a of lista) {
    entrada += a.entrada;
    saida += a.saida;
    if (porTipo[a.tipo] !== undefined) porTipo[a.tipo] += 1;
  }
  const total = lista.length;
  return {
    total,
    entrada, saida, tokens: entrada + saida,
    porTipo,
    mediaTokens: total ? Math.round((entrada + saida) / total) : 0,
    custo: temPreco() ? custoDe(entrada, saida) : null,
    custoMedio: temPreco() && total ? custoDe(entrada, saida) / total : null,
    ultima: lista[0]?.data || null,
    // Quantas análises ainda cabem no crédito informado — a pergunta real de
    // quem vai colocar dinheiro na conta.
    estimarRestantes(creditoEmReais) {
      if (!temPreco() || !total || !creditoEmReais) return null;
      const medio = custoDe(entrada, saida) / total;
      return medio > 0 ? Math.floor(creditoEmReais / medio) : null;
    },
  };
}
